import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { CondicionPagoSelect } from 'sharedComponents/select'

const CondicionPagoFormGroup = ({ iError, iTouched, fIsSubmitting, vIdDocumentoNota, flagEditarComentarios, flagGrifo }) => {
  return (
    <Form.Group>
      <Form.Label text='C. DE PAGO' htmlFor='select-CondicionDePago' md={flagGrifo ? 6 : 4} alignRightAt='md' />
      <Col md={flagGrifo ? 6 : 8}>
        <Field name='condicionPago'>
          {({ field }) => (
            <CondicionPagoSelect
              {...field}
              disabled={fIsSubmitting || !!vIdDocumentoNota || flagEditarComentarios}
              isInvalid={iTouched && iError}
              id='select-CondicionDePago'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CondicionPagoFormGroup)
